import { Types } from './actions'
const innitialState = {
  isLoading: false,
  isReady: false,
  supplierId: null,
  redemptionPoints: 0,
  minimumRedemptionLimit: 0,
  maximumRedemptionLimit: 0
}

export default (state = innitialState, action) => {
  switch (action.type) {
    case Types.TOGGLE_SUPPLIER_ID:
      return {
        ...state,
        isReady: false,
        supplierId: action.supplierId
      }
    case Types.CHANGE_REDEMPTION_POINTS:
      return { ...state, redemptionPoints: action.redemptionPoints }
    case Types.CHANGE_MINIMUM_REDEMPTION_LIMIT:
      return {
        ...state,
        isReady:
          state.supplierId !== null &&
          action.minimumRedemptionLimit > 0 &&
          state.maximumRedemptionLimit > 0,
        minimumRedemptionLimit: action.minimumRedemptionLimit
      }
    case Types.CHANGE_MAXIMUM_REDEMPTION_LIMIT:
      return {
        ...state,
        isReady:
          state.supplierId !== null &&
          state.minimumRedemptionLimit > 0 &&
          action.maximumRedemptionLimit > 0,
        maximumRedemptionLimit: action.maximumRedemptionLimit
      }
    default:
      return state || innitialState
  }
}



// WEBPACK FOOTER //
// ./src/features/Stix/reducer.js